import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import Footer from './components/Footer';
import Header from './components/Header';
import NewsEditPage from './pages/NewsEditPage';
import NewsOverviewPage from './pages/NewsOverviewPage';
import NewsPage from './pages/NewsPage';
import TeamEditPage from './pages/TeamEditPage';
import TeamOverviewPage from './pages/TeamOverviewPage';
import TeamPage from './pages/TeamPage';

export default function App() {
  return (
    <BrowserRouter>
      <div className="flex flex-col min-h-screen">
        <Header />

        <main id="main-content" className="grow-1">
          <Routes>
            <Route path="/" element={<Navigate to="/news" replace />} />

            <Route path="/news" element={<NewsOverviewPage />} />
            <Route path="/news/new" element={<NewsPage />} />
            <Route path="/news/edit/:id" element={<NewsEditPage />} />

            <Route path="/team" element={<TeamOverviewPage />} />
            <Route path="/team/new" element={<TeamPage />} />
            <Route path="/team/edit/:id" element={<TeamEditPage />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </BrowserRouter>
  );
}
